import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/utils/config/config.service';
import { Observable } from 'rxjs';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Injectable({
  providedIn: 'root'
})
export class UpSellingMessagesService {
  controller: string = "upselling/";

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService
  ) { }

  getImageBlob(id: number): Observable<Blob> {
    return this.http.get(this.config.apiUrl + this.controller + `imagen/${id}`, { responseType: 'blob' });
  }
 
  getMessages(): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + `avisos/${new Date().getTime()}`, {}, this.sesion.headers);
  }
  view(id: number): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + `view/${id} `, this.sesion.headers);
  }
  update(data: any): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + `update/${data.id} `, data, this.sesion.headers);
  }
  create(data: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + `create`, data, this.sesion.headers);
  }

  activate(id: number): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + `activate/${id} `, {}, this.sesion.headers);
  }

  deactivate(id: number): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + `deactivate/${id} `, {}, this.sesion.headers);
  }
}
